/** Client-safe validation rules for public receipt lookups. */

/** Base58 (Bitcoin alphabet), 64–88 chars — the shape of an ed25519 signature. */
export const SIGNATURE_RE = /^[1-9A-HJ-NP-Za-km-z]{64,88}$/;

export function isValidSignature(value: string): boolean {
  return SIGNATURE_RE.test(value.trim());
}
